import { handleApiErrorResponse } from "../lib/helpers";
import { workspaceRequestDispatch, workspaceRequestGetState } from "../lib/workspace_request_store";

const CREDIT_SUMMARY_CACHE_TTL = 30000;

export function getCreditSummaryService(formValues,token){
    let requestValues = formValues;
    let requestToken = token;

    // Backward compatibility: older callers pass only token.
    if (requestToken === undefined && typeof requestValues === "string") {
        requestToken = requestValues;
        requestValues = {};
    }

    if (!requestToken) {
        return Promise.resolve(null);
    }

    const normalizedWorkspaceId = requestValues && requestValues.workspace_id !== undefined && requestValues.workspace_id !== null
        ? String(requestValues.workspace_id)
        : "";
    const state = workspaceRequestGetState();
    const cachedCreditSummary = state.creditSummaryByWorkspaceId[normalizedWorkspaceId];
    const hasFreshCache = cachedCreditSummary && Date.now() - cachedCreditSummary.fetchedAt < CREDIT_SUMMARY_CACHE_TTL;

    if (hasFreshCache) {
        return Promise.resolve(cachedCreditSummary.response);
    }

    if (state.creditSummaryInFlightByWorkspaceId[normalizedWorkspaceId]) {
        return state.creditSummaryInFlightByWorkspaceId[normalizedWorkspaceId];
    }

    const requestPromise = fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/summary?workspace_id='+normalizedWorkspaceId, {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+requestToken}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    }).then((response) => {
        if (response && response.success) {
            workspaceRequestDispatch({
                type: "CACHE_CREDIT_SUMMARY_RESPONSE",
                payload: {
                    workspaceId: normalizedWorkspaceId,
                    response
                }
            });
        }
        return response;
    }).finally(() => {
        workspaceRequestDispatch({
            type: "CLEAR_CREDIT_SUMMARY_IN_FLIGHT",
            payload: {workspaceId: normalizedWorkspaceId}
        });
    });

    workspaceRequestDispatch({
        type: "SET_CREDIT_SUMMARY_IN_FLIGHT",
        payload: {
            workspaceId: normalizedWorkspaceId,
            requestPromise
        }
    });

    return requestPromise;
}
export function getCreditHistoryService(page,transactionOrder, workspace_id,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/history?workspace_id='+workspace_id+'&page='+page+'&order='+transactionOrder, {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function buyCreditsService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/buy', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function publishCreditsTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/test/publish', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function makePaymentForTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/test/pay', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function makePaymentService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/credits/pay', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    })
    .then((res)=>{
        handleApiErrorResponse(res); // check user is authenticate or not
        return res.json()

    } ).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function applyCouponService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/apply', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function applyCouponOnTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/test/apply', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}
export function removeCouponOnTestService(formValues,token){
    return fetch(process.env.REACT_APP_API_END_POINT+'researcher/promocodes/test/remove', {
        method: 'POST',
        body:JSON.stringify(formValues),
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}

export function getTesterCreditSummaryService(token){
    return fetch(process.env.REACT_APP_API_END_POINT+'user/tester/credits/summary', {
        method: 'GET',
        headers:{"Content-Type":"application/json","Accept":"application/json","Authorization":"Bearer "+token}
    }).then((res)=>{

        const isJson = res.headers.get('content-type')?.includes('application/json');
        const data = isJson ? res.json() : null;

        if (!res.ok) {
            // get error message from body or default to response status
            const error = (data && data.message) || res.status;
            return Promise.reject(error);
        }

        return data;

    }).catch((res)=>{
        handleApiErrorResponse(res);
    });
}